import { JSONClient } from './bootstrap';
import TidalException from './exception';

export const createLicenseKey = async ({
  licenseKey,
  name,
  licenseType,
  softwareId,
  purchasePrice,
  renewalPrice,
  renewalDate,
  renewalInterval,
  notes,
  tags,
}) => {
  try {
    const res = await JSONClient.post('/dashboard/licenses', {
      licenseKey,
      name,
      licenseType,
      softwareId,
      purchasePrice,
      renewalPrice,
      renewalDate,
      renewalInterval,
      notes,
      tags,
    });
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const editLicenseKey = async ({
  id,
  licenseKey,
  name,
  licenseType,
  softwareId,
  purchasePrice,
  renewalPrice,
  renewalDate,
  renewalInterval,
  notes,
  tags,
}) => {
  try {
    const res = await JSONClient.put(`/dashboard/licenses/${id}`, {
      licenseKey,
      name,
      licenseType,
      softwareId,
      purchasePrice,
      renewalPrice,
      renewalDate,
      renewalInterval,
      notes,
      tags,
    });
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const deleteLicenseKey = async ({ licenseId }) => {
  try {
    const res = await JSONClient.delete(`/dashboard/licenses/${licenseId}`);
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const getFullLicense = async ({ licenseId }) => {
  try {
    const res = await JSONClient.get(`/dashboard/licenses/${licenseId}/raw`);
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};
